import { render, staticRenderFns } from "./BulkMessagingSmsList.vue?vue&type=template&id=e959f10a&scoped=true&"
import script from "./BulkMessagingSmsList.vue?vue&type=script&lang=js&"
export * from "./BulkMessagingSmsList.vue?vue&type=script&lang=js&"
import style0 from "./BulkMessagingSmsList.vue?vue&type=style&index=0&id=e959f10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e959f10a",
  null
  
)

export default component.exports